import styled from "styled-components";

interface PageHeaderProps {
  noClientSelection?: boolean;
}

const PageHeader = styled.div<PageHeaderProps>`
  display: flex;
  align-items: center;
  padding: 15px 12px;
  
  @media (min-width: 1280px) {
    margin-top: ${(props) => (props.noClientSelection && "-55px")};
  }

  div {
    margin-right: 8px;
  }
`;

export { PageHeader };
